/* Common Imports */
import { Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { GetApp } from "@material-ui/icons";
import React from "react";
import ContactFormModal from "../../../modals/ContactFormModal";
import EdenBrochureDownloadModal from "../../../modals/EdenBrochureDownloadModal";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    width: "100%",
    padding: "0rem 1.5rem 0rem 1.5rem",
    [theme.breakpoints.up("md")]: {},
    // [theme.breakpoints.up("sm")]: {
    //     padding: "10rem 2rem 0rem 2rem",
    // },
    [theme.breakpoints.up(theme.breakpoints.values.sm + 168)]: {
      padding: "6.5rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.sm + 220)]: {
      padding: "10rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
    [theme.breakpoints.up(theme.breakpoints.values.md + 64)]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "1.5rem 1.5rem 1.5rem 1.5rem",
    height: "auto",
    boxShadow: "4px 10px 30px 0px rgba(0, 0, 0, 0.06)",
    borderRadius: "1.5rem 1.5rem 1.5rem 1.5rem",
    background: "#6934711F",
    border: "1px solid rgba(105, 52, 113, 0.12)",
    [theme.breakpoints.up("sm")]: {
      margin: "0rem 0rem 1.5rem 0rem",
    },
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    width: "100%",
  },
  heading: {
    width: "100%",
    color: "#693471",
    fontWeight: "500",
    fontSize: "3rem",
    lineHeight: "3.5rem",
    margin: "0rem 0rem 0.5rem 0rem",
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2rem",
      fontWeight: "600",
    },
  },
  subHeading: {
    margin: "0.5rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#212121",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1.75rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.5rem",
    },
  },
  btnRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "0.5rem",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row-reverse",
      justifyContent: "center",
      alignItems: "center",
      gap: "0.5rem",
      width: "100%",
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "row-reverse",
      justifyContent: "center",
      alignItems: "center",
      gap: "0.5rem",
      width: "100%",
      margin: "0rem 0rem 0rem 0rem",
    },
  },
  primaryButton: {
    padding: "0.5rem 1rem 0.5rem 1rem",
    background: "-webkit-linear-gradient(180deg, #502761 0%, #74378E 100%)",
    color: "#FFFFFF",
    margin: "1.5rem 0rem 0rem 0rem",
    fontSize: "1rem",
    fontWeight: "500",
    textTransform: "capitalize",
    borderRadius: "0.75rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      fontSize: "0.875rem",
      margin: "0.5rem 0rem 0rem 0rem",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      margin: "0.5rem 0rem 0rem 0rem",
      fontSize: "0.875rem",
    },
  },
  secondaryButton: {
    background: "#6934711F",
    color: "#5b2173",
    borderRadius: "0rem",
    border: "solid 1px #5b2173",
    margin: "1.5rem 0rem 0rem 0rem",
    padding: "0.5rem 1rem 0.5rem 1rem",
    fontSize: "1rem",
    fontWeight: "500",
    textTransform: "capitalize",
    borderRadius: "0.75rem",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
      margin: "0.5rem 0rem 0rem 0rem",
      fontSize: "0.875rem",
      background: "#6934711F",
    },
  },
  illustrationSizer: {
    width: "50%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8rem",
    objectFit: "contain",
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "8rem",
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "8rem",
    },
    [theme.breakpoints.down("md")]: {
      height: "auto",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "space-between",
      padding: "2rem",
    },
    [theme.breakpoints.down("sm")]: {
      // width: "210px",
      // padding: "2rem 0rem 2rem 0rem",
      display: "none",
    },
  },
}));
const LegendaryBeginningMobile = () => {
  const classes = useStyles();
  const [openContactForm, setOpenContactForm] = React.useState(false);
  const [openDownloadModal, setOpenDownloadModal] = React.useState(false);

  const handleOpenContactForm = () => {
    setOpenContactForm(true);
  };
  const handleCloseContactForm = () => {
    setOpenContactForm(false);
  };

  const handleOpenDownloadModal = () => {
    setOpenDownloadModal(true);
  };
  const handleCloseDownloadModal = () => {
    setOpenDownloadModal(false);
  };
  return (
    <React.Fragment>
      <ContactFormModal
        open={openContactForm}
        onClose={handleCloseContactForm}
        source="Heavie Eden"
      />
      <EdenBrochureDownloadModal
        open={openDownloadModal}
        onClose={handleCloseDownloadModal}
        source="Heavie Eden - Legendary Beginnings Mobile"
        title="Download Brochure"
        pdfURL="/pdf/heavie-eden-brochure.pdf"
      />
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <div className={classes.text}>
            <Typography
              variant="h2"
              component="span"
              className={classes.heading}
            >
              Legendary Beginnings
            </Typography>
            <Typography
              variant="h6"
              component="span"
              className={classes.subHeading}
            >
              The Garden of Eden to transform your reality
            </Typography>
            <div className={classes.btnRow}>
              <Button
                variant="outlined"
                onClick={handleOpenDownloadModal}
                title="Download Brochure"
                rel="noopener"
                className={classes.primaryButton}
                startIcon={<GetApp />}
              >
                Brochure
              </Button>
              <Button
                variant="outlined"
                onClick={handleOpenContactForm}
                title="Book a Site Visit"
                rel="noopener"
                className={classes.secondaryButton}
              >
                Book a Site Visit
              </Button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default LegendaryBeginningMobile;
